import React, { useState } from 'react';
import './LandingPage.css';

const AboutPage = ({ navigateTo }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.name && formData.email && formData.message) {
      setFormSubmitted(true);
      setTimeout(() => {
        setFormSubmitted(false);
        setFormData({ name: '', email: '', message: '' });
      }, 3000);
    }
  };

  return (
    <div className="app">
      {/* Header */}
      <header>
        <div className="container header-content">
          <h1 className="logo" onClick={() => navigateTo('home')} style={{cursor: 'pointer'}}>
            <span className="green">internet</span>
            <span className="purple">money</span>
            <span className="yellow">is</span>
            <span className="blue">serious</span>
            <span className="pink">.business</span>
          </h1>
          
          <nav className="main-nav">
            <a href="#" onClick={(e) => { e.preventDefault(); navigateTo('home'); }} className="nav-link">Home</a>
            <a href="#" onClick={(e) => { e.preventDefault(); navigateTo('videos'); }} className="nav-link">Videos</a>
            <a href="#" onClick={(e) => { e.preventDefault(); navigateTo('learn'); }} className="nav-link">Learn</a>
            <a href="#" onClick={(e) => { e.preventDefault(); navigateTo('about'); }} className="nav-link active">About</a>
          </nav>
          
          <button className="subscribe-btn" onClick={() => navigateTo('home')}>
            Subscribe
          </button>
        </div>
      </header>

      {/* About Page Content */}
      <section className="page-content">
        <div className="container">
          <div style={{marginTop: '2rem', marginBottom: '3rem'}}>
            <h1>About Us</h1>
            
            {/* Mission Section */}
            <div style={{marginTop: '2rem', marginBottom: '3rem'}}>
              <h2>Our Mission</h2>
              <p style={{fontSize: '1.1rem', lineHeight: '1.6', color: '#555'}}>
                At <strong>internetmoneyisserious.business</strong>, we believe that DeFi education should be 
                accessible, engaging, and digestible. We break down complex financial protocols into 
                bite-sized videos that anyone can understand, regardless of their technical background.
              </p>
              <p style={{fontSize: '1.1rem', lineHeight: '1.6', color: '#555'}}>
                Our focus on Uniswap v4 and Unichain reflects our commitment to covering the most 
                cutting-edge developments in decentralized finance, helping our audience stay ahead 
                of the curve in this rapidly evolving space.
              </p>
            </div>

            {/* What We Do */}
            <div style={{marginBottom: '3rem'}}>
              <h2>What We Do</h2>
              <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem', marginTop: '1rem'}}>
                <div style={{
                  padding: '1.5rem',
                  border: '1px solid #e5e7eb',
                  borderRadius: '8px',
                  backgroundColor: 'white'
                }}>
                  <h4 style={{color: '#6366f1'}}>📹 Video Content</h4>
                  <p>Short-form educational videos on YouTube and TikTok covering DeFi fundamentals, Uniswap mechanics, and advanced trading concepts.</p>
                </div>
                <div style={{
                  padding: '1.5rem',
                  border: '1px solid #e5e7eb',
                  borderRadius: '8px',
                  backgroundColor: 'white'
                }}>
                  <h4 style={{color: '#6366f1'}}>📚 Educational Resources</h4>
                  <p>Comprehensive learning paths and articles that guide you from DeFi basics to advanced strategies and protocol mechanics.</p>
                </div>
                <div style={{
                  padding: '1.5rem',
                  border: '1px solid #e5e7eb',
                  borderRadius: '8px',
                  backgroundColor: 'white'
                }}>
                  <h4 style={{color: '#6366f1'}}>🔍 Research & Analysis</h4>
                  <p>Deep dives into new protocols, yield opportunities, and market trends to help you make informed decisions in DeFi.</p>
                </div>
              </div>
            </div>

            {/* Our Approach */}
            <div style={{marginBottom: '3rem'}}>
              <h2>Our Approach</h2>
              <div style={{
                backgroundColor: '#f8fafc',
                padding: '2rem',
                borderRadius: '8px',
                marginTop: '1rem'
              }}>
                <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '2rem'}}>
                  <div>
                    <h4 style={{color: '#059669'}}>🎯 Clarity First</h4>
                    <p>No unnecessary jargon. We explain complex concepts in plain English with real-world examples.</p>
                  </div>
                  <div>
                    <h4 style={{color: '#7c3aed'}}>⚡ Quick & Actionable</h4>
                    <p>Our content respects your time. Learn what you need to know in under 60 seconds.</p>
                  </div>
                  <div>
                    <h4 style={{color: '#dc2626'}}>🛡️ Safety Focused</h4>
                    <p>We emphasize security best practices and highlight potential risks in every strategy we discuss.</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Stats */}
            <div style={{marginBottom: '3rem'}}>
              <h2>By The Numbers</h2>
              <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '1.5rem', marginTop: '1rem'}}>
                <div style={{textAlign: 'center'}}>
                  <div style={{fontSize: '2.5rem', fontWeight: 'bold', color: '#6366f1'}}>50K+</div>
                  <div style={{color: '#666'}}>Total Views</div>
                </div>
                <div style={{textAlign: 'center'}}>
                  <div style={{fontSize: '2.5rem', fontWeight: 'bold', color: '#6366f1'}}>100+</div>
                  <div style={{color: '#666'}}>Videos Created</div>
                </div>
                <div style={{textAlign: 'center'}}>
                  <div style={{fontSize: '2.5rem', fontWeight: 'bold', color: '#6366f1'}}>5K+</div>
                  <div style={{color: '#666'}}>Subscribers</div>
                </div>
                <div style={{textAlign: 'center'}}>
                  <div style={{fontSize: '2.5rem', fontWeight: 'bold', color: '#6366f1'}}>24/7</div>
                  <div style={{color: '#666'}}>Community Support</div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div style={{marginBottom: '3rem'}}>
              <h2>Get In Touch</h2>
              <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', marginTop: '2rem'}}>
                <div>
                  <p style={{marginBottom: '1.5rem'}}>
                    Have a question about DeFi? Want to suggest a topic for our next video? 
                    We'd love to hear from you!
                  </p>
                  
                  <div style={{marginBottom: '1rem'}}>
                    <strong>Email:</strong> hello@internetmoneyisserious.business
                  </div>
                  <div style={{marginBottom: '1rem'}}>
                    <strong>Discord:</strong> Join our community for real-time discussions
                  </div>
                  <div style={{marginBottom: '2rem'}}>
                    <strong>Response Time:</strong> We typically respond within 24 hours
                  </div>

                  <div>
                    <h4>Follow Us</h4>
                    <div style={{display: 'flex', gap: '1rem', marginTop: '0.5rem'}}>
                      <a href="https://youtube.com/@internetmoneyisserious" target="_blank" rel="noopener noreferrer" 
                         style={{color: '#6366f1', textDecoration: 'none'}}>YouTube</a>
                      <a href="https://tiktok.com/@internetmoneyisserious" target="_blank" rel="noopener noreferrer"
                         style={{color: '#6366f1', textDecoration: 'none'}}>TikTok</a>
                      <a href="https://twitter.com/imseriousbiz" target="_blank" rel="noopener noreferrer"
                         style={{color: '#6366f1', textDecoration: 'none'}}>Twitter</a>
                      <a href="https://discord.gg/defi" target="_blank" rel="noopener noreferrer"
                         style={{color: '#6366f1', textDecoration: 'none'}}>Discord</a>
                    </div>
                  </div>
                </div>

                <div>
                  <form onSubmit={handleSubmit} style={{display: 'flex', flexDirection: 'column', gap: '1rem'}}>
                    <div>
                      <label style={{display: 'block', marginBottom: '0.5rem', fontWeight: 'bold'}}>Name</label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                        style={{
                          width: '100%',
                          padding: '0.75rem',
                          border: '1px solid #d1d5db',
                          borderRadius: '6px',
                          fontSize: '1rem'
                        }}
                      />
                    </div>
                    <div>
                      <label style={{display: 'block', marginBottom: '0.5rem', fontWeight: 'bold'}}>Email</label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        style={{
                          width: '100%',
                          padding: '0.75rem',
                          border: '1px solid #d1d5db',
                          borderRadius: '6px',
                          fontSize: '1rem'
                        }}
                      />
                    </div>
                    <div>
                      <label style={{display: 'block', marginBottom: '0.5rem', fontWeight: 'bold'}}>Message</label>
                      <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleInputChange}
                        required
                        rows={5}
                        style={{
                          width: '100%',
                          padding: '0.75rem',
                          border: '1px solid #d1d5db',
                          borderRadius: '6px',
                          fontSize: '1rem',
                          resize: 'vertical'
                        }}
                      />
                    </div>
                    <button
                      type="submit"
                      style={{
                        padding: '0.75rem 1.5rem',
                        backgroundColor: formSubmitted ? '#10b981' : '#6366f1',
                        color: 'white',
                        border: 'none',
                        borderRadius: '6px',
                        fontSize: '1rem',
                        cursor: 'pointer',
                        transition: 'background-color 0.2s'
                      }}
                    >
                      {formSubmitted ? 'Message Sent! ✓' : 'Send Message'}
                    </button>
                  </form>
                  
                  {formSubmitted && (
                    <p style={{color: '#10b981', marginTop: '1rem'}}>
                      Thanks for reaching out! We'll get back to you soon.
                    </p>
                  )}
                </div>
              </div>
            </div>

            {/* Disclaimer */}
            <div style={{
              backgroundColor: '#fef3cd',
              border: '1px solid #fbbf24',
              borderRadius: '8px',
              padding: '1.5rem',
              marginTop: '2rem'
            }}>
              <h4 style={{color: '#92400e', margin: '0 0 0.5rem 0'}}>⚠️ Important Disclaimer</h4>
              <p style={{color: '#92400e', margin: 0}}>
                Our content is for educational purposes only and should not be considered financial advice. 
                DeFi protocols carry inherent risks including smart contract vulnerabilities, impermanent loss, 
                and market volatility. Always do your own research and consider consulting with a qualified 
                financial advisor before making any investment decisions.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer style={{marginTop: '3rem'}}>
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <h2 className="logo">
                <span className="green">internet</span>
                <span className="purple">money</span>
                <span className="yellow">is</span>
                <span className="blue">serious</span>
                <span className="pink">.business</span>
              </h2>
              <p>DeFi education in bite-sized videos</p>
            </div>
            
            <div className="footer-links">
              <a href="https://youtube.com/@internetmoneyisserious" target="_blank" rel="noopener noreferrer">YouTube</a>
              <a href="https://tiktok.com/@internetmoneyisserious" target="_blank" rel="noopener noreferrer">TikTok</a>
              <a href="https://twitter.com/imseriousbiz" target="_blank" rel="noopener noreferrer">Twitter</a>
              <a href="https://discord.gg/defi" target="_blank" rel="noopener noreferrer">Discord</a>
              <a href="#" onClick={(e) => { e.preventDefault(); navigateTo('about'); }}>Contact</a>
            </div>
          </div>
          
          <div className="copyright">
            &copy; {new Date().getFullYear()} internetmoneyisserious.business | Not financial advice
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AboutPage;